import { h } from "preact";

import IconProps from "./IconProps";

function IconFigmaFeedback({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? "#0ACF83";

    return (
        <svg class={cssClass} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.756 18.032c1.521 0 2.756-1.197 2.756-2.672v-2.672H5.756C4.235 12.688 3 13.884 3 15.36s1.235 2.672 2.756 2.672z" fill={fill}/>
            <path d="M3 10.016c0-1.475 1.235-2.672 2.757-2.672h2.756v5.344H5.756C4.235 12.688 3 11.49 3 10.016z" fill="#A259FF"/>
            <path d="M3.001 4.672C3.001 3.197 4.235 2 5.756 2h2.757v5.344H5.756c-1.52 0-2.755-1.197-2.755-2.672z" fill="#F24E1E"/>
            <path d="M8.512 2h2.756c1.522 0 2.756 1.197 2.756 2.672s-1.234 2.673-2.756 2.673H8.512V2z" fill="#FF7262"/>
            <path d="M11.268 7.344c1.521 0 2.756 1.197 2.756 2.672h-1.57a1.87 1.87 0 0 0-1.71 2.622c-1.27-.238-2.232-1.32-2.232-2.622 0-1.475 1.235-2.672 2.756-2.672zm2.54 3.709a2.736 2.736 0 0 1-1.8 1.534.831.831 0 0 1 .447-1.534h1.353z" fill="#1ABCFE"/>
            <path d="M10.294 18.756a.833.833 0 0 0 1.179 0l4.862-4.86v2.7a.833.833 0 0 0 1.665 0v-4.71a.833.833 0 0 0-.833-.833h-4.713a.833.833 0 1 0 0 1.664h2.703l-4.863 4.861a.833.833 0 0 0 0 1.178z" fill="#3F3F46"/>
        </svg>

    );
}

export default IconFigmaFeedback;
